import {
  type BackupVault,
  Provider,
  ResourceType,
  VaultStorageTier,
} from '@repo/api-gw-sdk';

export const COLD_TIER_SUPPORTED_RESOURCE_TYPES: ResourceType[] = [
  ResourceType.AwsS3,
];

export const isVaultSupportedForStorageTier = (
  vault: BackupVault,
  vaultStorageTier: VaultStorageTier
): boolean =>
  vaultStorageTier !== VaultStorageTier.VAULT_STORAGE_TIER_COLD ||
  vault.vaultAttributes?.cloudProvider === Provider.Aws;
